export default "__VITE_ASSET__85o0BDJo__"